import React from "react";
import { observer } from "mobx-react";
import { AuthorComposerViewStore } from "../../store";
import { AuthorComposerViewForm } from "./AuthorComposerViewForm";
import { ErrorDialog } from "../../../../common/controls";
import { DownloadIcon } from "../../../../icons";
import { VisibilityIcon } from "../../../../icons";
import { isOriginalCrudStatus, RowCrudStatus } from "../../../common/types";
import { useRootStore } from "../../../../store/contexts";
import { PDFViewerDialog } from "../../../../common/components/PDFViewerDialog";

export type AuthorComposerViewProps = {
  authorComposerViewStore: AuthorComposerViewStore;
};

export const AuthorComposerView: React.FC<AuthorComposerViewProps> = observer(
  ({ authorComposerViewStore }) => {
    const { langStore } = useRootStore();

    const getViewAction = (
      onDownload: (props: {
        id: string;
        type: string;
        name: string;
        __status__: RowCrudStatus;
      }) => void,
      onViewPdf?: (props: any) => void
    ) => {
      const actions: any[] = [];
      if (onViewPdf) {
        actions.push({
          columnName: "__action_view_pdf",
          onClick: (props: any) =>
            isOriginalCrudStatus(props.__status__) ? onViewPdf(props) : {},
          icon: <VisibilityIcon />,
          label: langStore.viewCommand,
          isActionEnabled: (props: any) =>
            props.name?.toLowerCase().endsWith(".pdf"),
        });
      }
      actions.push({
        columnName: "__action_view",
        onClick: (props: any) =>
          isOriginalCrudStatus(props.__status__) ? onDownload(props) : {},
        icon: <DownloadIcon />,
        label: langStore.downloadCommand,
      });
      return actions;
    };

    return (
      <div>
        <AuthorComposerViewForm
          authorComposerViewStore={authorComposerViewStore}
          firstName={authorComposerViewStore.firstNameValue}
          lastName={authorComposerViewStore.lastNameValue}
          genderOptions={authorComposerViewStore.getGenderOptions()}
          gender={authorComposerViewStore.genderValue}
          taxIdTypeOptions={authorComposerViewStore.getTaxIdTypeOptions()}
          taxIdType={authorComposerViewStore.taxIdTypeValue}
          taxId={authorComposerViewStore.taxIdValue}
          cuitCertificateFiles={authorComposerViewStore.cuitCertificateFiles}
          cuitCertificateIssuedAt={
            authorComposerViewStore.cuitCertificateIssuedAtValue
          }
          cuitCertificateError={
            authorComposerViewStore.cuitCertificateErrorValue
          }
          cuitCertificateErrorTypeOptions={authorComposerViewStore.getCuitCertificateErrorTypeOptions()}
          cuitCertificateErrorType={
            authorComposerViewStore.cuitCertificateErrorTypeValue
          }
          dniDeliveredToSadaicAt={
            authorComposerViewStore.dniDeliveredToSadaicAtValue
          }
          dniValidatedAt={authorComposerViewStore.dniValidatedAtValue}
          email={authorComposerViewStore.emailValue}
          phone={authorComposerViewStore.phoneValue}
          nationalityValue={authorComposerViewStore.nationalityValue}
          dateOfBirth={authorComposerViewStore.dateOfBirthValue}
          streetAndNumber={authorComposerViewStore.streetAndNumberValue}
          floor={authorComposerViewStore.floorValue}
          suite={authorComposerViewStore.suiteValue}
          postalCode={authorComposerViewStore.postalCodeValue}
          countryValue={authorComposerViewStore.countryValue}
          provinceValue={authorComposerViewStore.provinceValue}
          city={authorComposerViewStore.cityValue}
          aka={authorComposerViewStore.akaValue}
          ipi={authorComposerViewStore.ipiValue}
          managementSocietiesVisibleColumns={
            authorComposerViewStore.managementSocietiesVisibleColumns
          }
          managementSocietiesSetColumnWiths={(x) =>
            authorComposerViewStore.managementSocietiesSetColumnWiths(x)
          }
          managementSocietiesRows={
            authorComposerViewStore.managementSocietiesRowsDyn
          }
          publishersVisibleColumns={
            authorComposerViewStore.publishersVisibleColumns
          }
          publishersSetColumnWiths={(x) =>
            authorComposerViewStore.publishersSetColumnWiths(x)
          }
          publishersRows={authorComposerViewStore.publishersRowsDyn}
          createdAt_={authorComposerViewStore.createdAt_Value}
          lastUpdatedAt_={authorComposerViewStore.lastUpdatedAt_Value}
          recordId={authorComposerViewStore.authorComposerInstance?.id || ""}
          onPrint={(handlePrint: () => void) =>
            authorComposerViewStore.printAuthorComposer(handlePrint)
          }
          onCancel={() => authorComposerViewStore.cancelAuthorComposer()}
          onEdit={
            authorComposerViewStore.isEditEnabled
              ? () => authorComposerViewStore.editAuthorComposer()
              : undefined
          }
          cuitCertificateViewAction={getViewAction(
            (props) =>
              authorComposerViewStore.fileDownload(props, "cuitCertificate"),
            (props) =>
              authorComposerViewStore.viewFilePdf(props, "cuitCertificate")
          )}
        />
        <ErrorDialog
          open={authorComposerViewStore.errorDialogOpened}
          title={authorComposerViewStore.errorTitle}
          description={authorComposerViewStore.errorDescription}
          onClose={() => authorComposerViewStore.closeErrorDialog()}
        />
        <PDFViewerDialog
          open={authorComposerViewStore.pdfViewerOpen}
          onClose={() => authorComposerViewStore.closePdfViewer()}
          pdfUrl={authorComposerViewStore.pdfViewerUrl}
          title={authorComposerViewStore.pdfViewerTitle}
        />
      </div>
    );
  }
);
